import * as Types from '../../../gql/types';

import {gql} from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SendContactFormMutationVariables = Types.Exact<{
  payload: Types.ContactInput;
}>;

export type SendContactFormMutation = {
  __typename?: 'Mutation';
  sendContactForm?: {
    __typename?: 'SendContactFormPayload';
    errors: Array<{
      __typename?: 'Error';
      message: string;
      path?: Array<string> | null;
    }>;
  } | null;
};

export const SendContactFormDocument = gql`
  mutation sendContactForm($payload: ContactInput!) {
    sendContactForm(payload: $payload) {
      errors {
        message
        path
      }
    }
  }
`;
export type SendContactFormMutationFn = ApolloReactCommon.MutationFunction<
  SendContactFormMutation,
  SendContactFormMutationVariables
>;

/**
 * __useSendContactFormMutation__
 *
 * To run a mutation, you first call `useSendContactFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactFormMutation, { data, loading, error }] = useSendContactFormMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendContactFormMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendContactFormMutation,
    SendContactFormMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SendContactFormMutation,
    SendContactFormMutationVariables
  >(SendContactFormDocument, options);
}
export type SendContactFormMutationHookResult = ReturnType<
  typeof useSendContactFormMutation
>;
export type SendContactFormMutationResult =
  ApolloReactCommon.MutationResult<SendContactFormMutation>;
export type SendContactFormMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendContactFormMutation,
    SendContactFormMutationVariables
  >;
